"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _helpers = require("@qwkin/helpers");
var _Card = require("../Card");
var _Button = require("../Button");
var _ChipItem = require("../ChipItem");
var _AttachmentUploader = require("./AttachmentUploader.styles");
var _theme = require("../utils/theme");
var _Text = require("../Text");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var AttachmentUploader = function AttachmentUploader(_ref) {
  var _ref$multiple = _ref.multiple,
    multiple = _ref$multiple === void 0 ? false : _ref$multiple,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Attached Media' : _ref$title,
    helperText = _ref.helperText,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? 'Add Media' : _ref$label,
    _ref$accept = _ref.accept,
    accept = _ref$accept === void 0 ? ['.jpg', '.jpeg', '.png', '.pdf', '.docx', '.doc', '.xls', '.xlsx'] : _ref$accept,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? _helpers.identity : _ref$onChange,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? _theme.defaultTheme : _ref$theme;
  var _useState = (0, _react.useState)([]),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    attachments = _useState2[0],
    setAttachments = _useState2[1];
  var handleAttachmentsChange = function handleAttachmentsChange() {
    return document.getElementById('changeCurrentAttachments').click();
  };
  var handleChange = function handleChange(_ref2) {
    var files = _ref2.target.files;
    return setAttachments([].concat((0, _toConsumableArray2["default"])(attachments), (0, _toConsumableArray2["default"])(files)));
  };
  var removeFromAttachments = function removeFromAttachments(attachment) {
    var index = attachments.findIndex(function (a) {
      return a === attachment;
    });
    if (index !== -1) {
      attachments.splice(index, 1);
    }
    setAttachments((0, _toConsumableArray2["default"])(attachments));
  };
  (0, _react.useEffect)(function () {
    if (attachments.length > 0) {
      onChange(attachments);
    }
  }, [attachments]);
  return /*#__PURE__*/_react["default"].createElement(_Card.Card, {
    dense: true,
    padding: "4px",
    title: /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Text.Text, {
      weight: "bold"
    }, title), helperText && /*#__PURE__*/_react["default"].createElement(_Text.Text, {
      style: {
        fontSize: '0.6em'
      }
    }, helperText)),
    style: {
      width: '100%'
    },
    actions: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Button.Button, {
      dense: true,
      outline: true,
      icon: "add",
      themeColor: theme.color.success,
      onClick: handleAttachmentsChange
    }, label), /*#__PURE__*/_react["default"].createElement("input", {
      multiple: multiple,
      id: "changeCurrentAttachments",
      hidden: true,
      type: "file",
      onChange: handleChange,
      accept: accept.join(',')
    }))
  }, attachments.map(function (attachment) {
    return /*#__PURE__*/_react["default"].createElement(_AttachmentUploader.ChipsContainer, {
      key: attachment === null || attachment === void 0 ? void 0 : attachment.name
    }, /*#__PURE__*/_react["default"].createElement(_ChipItem.ChipItem, {
      themeColor: theme.color.primary,
      style: {
        margin: '4px'
      },
      label: attachment === null || attachment === void 0 ? void 0 : attachment.name,
      onClick: function onClick() {
        return removeFromAttachments(attachment);
      }
    }));
  }));
};
var _default = exports["default"] = AttachmentUploader;